<template>
    <div class="form-group select" v-if="skus.length > 0 && skus[0].product.strategy === 'advanced'">
        <label
            :for="name"
            class="control-label"
        >
            <slot>Sku</slot>
        </label>
        <select
            :name="name"
            :id="name"
            v-model="model"
            data-vv-as="sku"
            class=" form-control"
            v-validate.immediate="'required'"
        >
            <option
                value=""
                v-text="skus.length ? `--Select Product Sku--` : `--No Product Sku Found--`"
            ></option>
            <option
                v-if="skus.length"
                v-for="sku in displayableSkus"
                :key="sku.id"
                :value="sku.id"
                v-text="sku.label"
            ></option>
        </select>
        <span class="text-danger"
              v-if="vErrors.has(name)">{{ vErrors.first(name) }}</span>
    </div>
</template>

<script>
//See if we can factor this out and use EntitySelectMenu instead.
export default {
    name: "SkuSelect",
    inject: ['$validator'],
    props: {
        name: {
            default: `sku_id`,
            required: false,
            type: String,
        },

        skus: {
            required: true,
            type: Array,
        },
    },
    data() {
        return {
            model: '',
        }
    },
    computed: {
        displayableSkus() {
            return this.skus
                .map(sku => {
                    let {id, label} = sku;

                    return { id, label }
                });
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/AAA_TO_REFACTOR/SkuSelect.vue